import React, { useCallback } from 'react';
import { useReminderModal } from '../ReminderModalContext';
import { useGuestGuideTelemetry } from '../GuestGuideTelemetry';
import { useIsFeatureEnabled } from '@shared/core/featureFlags';
import { useEventInfo } from '@shared/utils/eventInfo';
import { useEventWithinReminderWindow } from '@shared/hooks/useEventWithinReminderWindow';
import { useTranslation } from '@shared/core';
import { GuestGuideActionButton } from '../GuestGuideActionButton';
import { AlarmClock } from '@withjoy/joykit/icons';

// Dedicated reminder action component
export const RemindMeToBookStayAction: React.FC = () => {
  const { onOpen } = useReminderModal();
  const telemetry = useGuestGuideTelemetry();
  const { eventInfo } = useEventInfo();
  const { tq } = useTranslation('guestGuide');

  const eventDate = eventInfo?.finalizedDate?.dateString ? new Date(eventInfo.finalizedDate.dateString) : null;
  const isEventWithinReminderWindow = useEventWithinReminderWindow(eventDate);
  const [remindMeLaterInGuestGuide] = useIsFeatureEnabled('remindMeLaterInGuestGuide', { skip: !isEventWithinReminderWindow });

  const handleClick = useCallback(() => {
    telemetry.clickRemindMeToBookStay();
    onOpen();
  }, [telemetry, onOpen]);

  if (!remindMeLaterInGuestGuide) {
    return null;
  }

  return (
    <GuestGuideActionButton
      icon={<AlarmClock size={32} />}
      onClick={handleClick}
    >
      {tq`Remind to Book`}
    </GuestGuideActionButton>
  );
};
